import { useState } from "react";

const useHeaderTitleManager = () => {
  const [headerTitle, setHeaderTitle] = useState("Zoning Info");

  return [headerTitle, setHeaderTitle];
};

export default useHeaderTitleManager;
